import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTenantTranslation } from "hooks/formatters";

export const SignInLinkDialog = ({
  isOpen,
  signInLink,
  onClose,
}: {
  isOpen: boolean;
  signInLink: string;
  onClose: () => void;
}) => {
  const { t } = useTenantTranslation();
  const [linkCopiedOpen, setLinkCopiedOpen] = useState(false);

  const handleCopyLink = async () => {
    await navigator.clipboard.writeText(signInLink);
    setLinkCopiedOpen(true);
  };

  return (
    <>
      <Dialog open={isOpen} onClose={onClose}>
        <DialogTitle>{t("createInviteLink")}</DialogTitle>
        <DialogContent sx={{ minWidth: "500px" }}>
          <Stack sx={{ m: 1, gap: 2 }}>
            <Typography>{t("signInLinkGenerated")}</Typography>
            <Stack direction="row" alignItems="center" gap={1}>
              <TextField
                fullWidth
                value={signInLink}
                slotProps={{
                  input: {
                    readOnly: true,
                  },
                }}
                sx={{ flex: 1 }}
              />
              <IconButton onClick={() => void handleCopyLink()}>
                <ContentCopyIcon />
              </IconButton>
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => void handleCopyLink()}>
            {t("copyLink")}
          </Button>
          <Button variant="contained" onClick={onClose}>
            {t("done")}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={linkCopiedOpen}
        autoHideDuration={3000}
        onClose={() => {
          setLinkCopiedOpen(false);
        }}
      >
        <Alert severity="success">{t("linkCopied")}</Alert>
      </Snackbar>
    </>
  );
};
